import { render } from "./aButton.vue?vue&type=template&id=57a800d0"
import script from "./aButton.vue?vue&type=script&lang=js"
export * from "./aButton.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__